import axios from "axios";
import { api_urls } from "../../utils/api-urls";
import Swal from "sweetalert2";
import { call, put, takeLeading } from "redux-saga/effects";
import { Color } from "../../assets/colors";
import * as actionTypes from '../actionTypes';
import { deleteAPI, getAPI, postAPI, putAPI } from "../../utils/api-function";
import { create_live, delete_live, get_live, update_live, change_podcast_status, create_podcast, delete_podcast, get_podcast, update_podcast, change_videoclip_status, create_videoclip, delete_videoclip, get_videoclip, update_videoclip, change_news_status, create_news, delete_news, get_news, update_news } from "../../utils/api-routes";

//! Podcast
function* getPodcast() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_podcast}`);
        console.log("Get Podcast Saga Response ::: ", data)

        if (data?.status) {
            yield put({ type: actionTypes.SET_PODCAST, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Podcast Saga Error ::: ", error)
    }
}

function* createPodcast(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_podcast}`, payload?.data);
        console.log("Create Podcast Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: " Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create ',
            text: "Failed To Create ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Podcast Saga Error ::: ", error?.response?.data)
    }
}

function* updatePodcast(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_podcast}`, payload?.data);
        console.log("Update Podcast Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: " Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_PODCAST, payload: null })
        }

    } catch (error) {
        console.log("Update Podcast Saga Error ::: ", error?.response?.data)
    }
}

function* deletePodcast(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_podcast}`, payload);
            console.log("Delete Podcast Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: " Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_PODCAST, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Podcast Saga Error ::: ", error?.response?.data)
    }
}

function* changePodcastStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_podcast_status}`, payload);
            console.log("Change Status Podcast Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_PODCAST, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Podcast Saga Error ::: ", error?.response?.data)
    }
}

//! Videoclip
function* getVideoclip() {
    try {
        console.log('Tested')
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_videoclip}`);
        console.log("Get Videoclip Saga Response ::: ", data)

        if (data?.status) {
            yield put({ type: actionTypes.SET_VIDEOCLIP, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Videoclip Saga Error ::: ", error)
    }
}

function* createVideoclip(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_videoclip}`, payload?.data);
        console.log("Create Videoclip Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: " Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create ',
            // title: error?.response?.data?.message.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            text: "Failed To Create ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Videoclip Saga Error ::: ", error?.response?.data)
    }
}

function* updateVideoclip(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_videoclip}`, payload?.data);
        console.log("Update Videoclip Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: " Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_VIDEOCLIP, payload: null })
        }

    } catch (error) {
        console.log("Update Videoclip Saga Error ::: ", error?.response?.data)
    }
}

function* deleteVideoclip(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_videoclip}`, payload);
            console.log("Delete Videoclip Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: " Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_VIDEOCLIP, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Videoclip Saga Error ::: ", error?.response?.data)
    }
}

function* changeVideoclipStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_videoclip_status}`, payload);
            console.log("Change Status Videoclip Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_VIDEOCLIP, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Videoclip Saga Error ::: ", error?.response?.data)
    }
}

//! News

function* getNews() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_news}`);
        console.log("Get News Saga Response ::: ", data)

        if (data?.status) {
            yield put({ type: actionTypes.SET_NEWS, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get News Saga Error ::: ", error)
    }
}

function* createNews(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_news}`, payload?.data);
        console.log("Create News Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: " Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Create ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create News Saga Error ::: ", error?.response?.data)
    }
}

function* updateNews(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_news}`, payload?.data);
        console.log("Update News Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: " Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_NEWS, payload: null })
        }

    } catch (error) {
        console.log("Update News Saga Error ::: ", error?.response?.data)
    }
}

function* deleteNews(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_news}`, payload);
            console.log("Delete News Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    text: " Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_NEWS, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete News Saga Error ::: ", error?.response?.data)
    }
}

function* changeNewsStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_news_status}`, payload);
            console.log("Change Status News Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    text: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_NEWS, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status News Saga Error ::: ", error?.response?.data)
    }
}


//! Live 
function* getLive() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_live);
        console.log("Get Live Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_LIVE, payload: data?.data?.reverse() });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Live Saga Error ::: ", error);
    }
};

function* createLive(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield postAPI(create_live, payload?.data);
        console.log("Create Live Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Live Created Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: error?.response?.data?.message, showConfirmButton: false, timer: 2000 });
        console.log("Create Live Saga Error ::: ", error);
    }
};

function* updateLive(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield putAPI(update_live(payload?.id), payload?.data);
        console.log("Update Live Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Live Updated Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: error?.response?.data?.message, showConfirmButton: false, timer: 2000 });
        console.log("Update Live Saga Error ::: ", error);
    }
};

function* deleteLive(action) {
    try {
        const { payload } = action;

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete!!!", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: 'grey', confirmButtonText: "Yes", cancelButtonText: "No" });

        if (result.isConfirmed) {
            const { data } = yield deleteAPI(delete_live(payload?.id));
            console.log("Delete Live Saga Response ::: ", data);

            if (data?.success) {
                Swal.fire({ icon: "success", title: 'Success', text: "Live Deleted Successfully", showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes?.GET_LIVE, payload: null });
            }
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Delete", showConfirmButton: false, timer: 2000 });
        console.log("Delete Live Saga Error ::: ", error);
    }
};

export default function* sancharSaga() {
    //! Podcast
    yield takeLeading(actionTypes?.GET_PODCAST, getPodcast);
    yield takeLeading(actionTypes?.CREATE_PODCAST, createPodcast);
    yield takeLeading(actionTypes?.UPDATE_PODCAST, updatePodcast);
    yield takeLeading(actionTypes?.DELETE_PODCAST, deletePodcast);
    yield takeLeading(actionTypes?.CHANGE_PODCAST_STATUS, changePodcastStatus);

    //! Videoclip
    yield takeLeading(actionTypes?.GET_VIDEOCLIP, getVideoclip);
    yield takeLeading(actionTypes?.CREATE_VIDEOCLIP, createVideoclip);
    yield takeLeading(actionTypes?.UPDATE_VIDEOCLIP, updateVideoclip);
    yield takeLeading(actionTypes?.DELETE_VIDEOCLIP, deleteVideoclip);
    yield takeLeading(actionTypes?.CHANGE_VIDEOCLIP_STATUS, changeVideoclipStatus);

    //! News
    yield takeLeading(actionTypes?.GET_NEWS, getNews);
    yield takeLeading(actionTypes?.CREATE_NEWS, createNews);
    yield takeLeading(actionTypes?.UPDATE_NEWS, updateNews);
    yield takeLeading(actionTypes?.DELETE_NEWS, deleteNews);
    yield takeLeading(actionTypes?.CHANGE_NEWS_STATUS, changeNewsStatus);

    //! Live
    yield takeLeading(actionTypes?.GET_LIVE, getLive);
    yield takeLeading(actionTypes?.CREATE_LIVE, createLive);
    yield takeLeading(actionTypes?.UPDATE_LIVE, updateLive);
    yield takeLeading(actionTypes?.DELETE_LIVE, deleteLive);
};